// Editor input is the post-convert "full markdown" string (body + footnote
// definitions concatenated). splitMarkdownToBranches expects them split
// apart, with footnotes pre-formatted with 4-space-indented continuations.
// This helper does the split exactly the way convertHtmlToMarkdown produces
// them, so what comes out of /editor's textarea round-trips through the
// pipeline.
//
// All footnote definitions in a Plan A doc live at the bottom of the
// document. The first `[^N]:` at line start marks the start of the block.
export function splitFootnotesFromFullMarkdown(fullMarkdown: string): {
  bodyMarkdown: string
  footnotesContent: string
} {
  const footnoteDefStartMatch = fullMarkdown.match(/^\[\^\d+\]:/m)
  if (!footnoteDefStartMatch || footnoteDefStartMatch.index === undefined) {
    return { bodyMarkdown: fullMarkdown, footnotesContent: '' }
  }
  return {
    bodyMarkdown: fullMarkdown.substring(0, footnoteDefStartMatch.index),
    footnotesContent: fullMarkdown.substring(footnoteDefStartMatch.index),
  }
}
